<template>
    <ModalContainer :visible="visible" :show-header="false" :show-footer="false" :loading="loading">
        <template v-slot:body>
            <div class="container-fluid">
                <div class="margin-bottom-20 text-right clearfix">
                    <button type="button" class="close" @click="closeModal()"><i class="las la-times"></i> {{$t('common.close')}}</button>
                </div>
            </div>
            <div class="container">
                <div v-if="!locked" class="embed-responsive embed-responsive-16by9 margin-bottom-20">
                        <vueVimeoPlayer v-if="video.video_id" ref="player" :video-id="video.video_id"/>
                </div>

                <div v-else class="margin-bottom-20"  v-bind:style="{ 'background-image': 'url(https://i.vimeocdn.com/video/' + video.picture_id  + '-' + video.picture_key +'-d_1200x500)', 'background-size': 'cover', 'background-position': 'center' }">
                    <div class="showcase-access-box">
                        <div>
                            <p class="margin-bottom-20"><button class="btn btn-primary btn-lg" @click.prevent.stop="$emit('go-to-checkout')">{{$t('views.showcase_consumer.get_access')}}</button></p>
                            {{$t('views.showcase_consumer.or_sign_in_1')}} <a href="" @click.prevent.stop="$emit('sign-in')">{{$t('common.sign_in')}}</a> {{$t('views.showcase_consumer.or_sign_in_2')}}.
                        </div>
                    </div>
                </div>
                <h1>{{video.title}}</h1>
                {{video.description}}
            </div>
        </template>
    </ModalContainer>
</template>

<script>
import ModalContainer from "./ModalContainer";
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
    name: "PlayShowcaseModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        locked: {
            type: Boolean,
            default: false
        },
        video: {
            type: Object,
            required: true
        },
        showcase: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            errorMessage:""
        }
    },
    methods: {
        closeModal() {
            this.$emit('close-play-showcase-modal');
            if (this.video.video_id) {
                this.$refs.player.pause();
            }
        }
    },
    components: {ModalContainer, vueVimeoPlayer},
};
</script>
